import React, { useState } from 'react';
import { IconCrown, IconBrain, IconChartLine, IconUserTie, IconShield, IconChevronDown, IconChevronUp, IconArrowRight } from './Icons';
import { useLanguage } from '../context/LanguageContext';
import useScrollReveal from '../hooks/useScrollReveal';
import './TeamSection.css';

const TeamSection = () => {
  const { t } = useLanguage();
  const [expandedFeature, setExpandedFeature] = useState(null);

  const features = [
    { id: 1, icon: 'brain', title: t.teamSection.feature1Title, subtitle: t.teamSection.feature1Subtitle, description: t.teamSection.feature1Desc },
    { id: 2, icon: 'chart-line', title: t.teamSection.feature2Title, subtitle: t.teamSection.feature2Subtitle, description: t.teamSection.feature2Desc },
    { id: 3, icon: 'user-tie', title: t.teamSection.feature3Title, subtitle: t.teamSection.feature3Subtitle, description: t.teamSection.feature3Desc },
    { id: 4, icon: 'shield', title: t.teamSection.feature4Title, subtitle: t.teamSection.feature4Subtitle, description: t.teamSection.feature4Desc },
  ];

  const getFeatureIcon = (iconType) => {
    switch(iconType) {
      case 'brain': return <IconBrain size={22} />;
      case 'chart-line': return <IconChartLine size={22} />;
      case 'user-tie': return <IconUserTie size={22} />;
      case 'shield': return <IconShield size={22} />;
      default: return <IconBrain size={22} />;
    }
  };

  const toggleFeature = (id) => {
    setExpandedFeature(expandedFeature === id ? null : id);
  };

  const headerReveal = useScrollReveal({ threshold: 0.15 });
  const teamReveal = useScrollReveal({ threshold: 0.1 });
  const featuresReveal = useScrollReveal({ threshold: 0.1 });

  return (
    <section className="team-section-fox" id="team">
      <div className="team-section-fox__bg-glow team-section-fox__bg-glow--1"></div>
      <div className="team-section-fox__bg-glow team-section-fox__bg-glow--2"></div>
      
      <div className="team-section-fox__container">
        <div ref={headerReveal.ref} className={`team-section-fox__header reveal ${headerReveal.isRevealed ? 'reveal--visible' : ''}`}>
          <span className="team-section-fox__label"><IconCrown size={22} />{t.teamSection.label}</span>
          <h2 className="team-section-fox__title">
            {t.teamSection.title} <span className="team-section-fox__title-gradient">{t.teamSection.titleHighlight}</span>
          </h2>
          <p className="team-section-fox__subtitle">{t.teamSection.subtitle}</p>
        </div>

        <div className="team-section-fox__content">
          <div ref={teamReveal.ref} className={`team-section-fox__team reveal--left ${teamReveal.isRevealed ? 'reveal--visible' : ''}`}>
            <div className="team-section-fox__team-wrapper">
              <img src="/img/team-1.png" alt={t.teamSection.teamImageAlt} className="team-section-fox__team-image" width={500} height={400} loading="lazy" decoding="async" />
            </div>
          </div>

          <div ref={featuresReveal.ref} className={`team-section-fox__features-wrapper reveal--right ${featuresReveal.isRevealed ? 'reveal--visible' : ''}`}>
            <div className="team-section-fox__features">
              {features.map((feature) => (
                <div key={feature.id} className={`team-section-fox__feature ${expandedFeature === feature.id ? 'team-section-fox__feature--expanded' : ''}`}>
                  <button className="team-section-fox__feature-header" onClick={() => toggleFeature(feature.id)} aria-expanded={expandedFeature === feature.id}>
                    <div className="team-section-fox__feature-icon">{getFeatureIcon(feature.icon)}</div>
                    <div className="team-section-fox__feature-text">
                      <h4 className="team-section-fox__feature-title">{feature.title}</h4>
                      <p className="team-section-fox__feature-subtitle">{feature.subtitle}</p>
                    </div>
                    <div className="team-section-fox__feature-toggle">
                      {expandedFeature === feature.id ? <IconChevronUp size={18} /> : <IconChevronDown size={18} />}
                    </div>
                  </button>
                  {expandedFeature === feature.id && (
                    <div className="team-section-fox__feature-content"><p>{feature.description}</p></div>
                  )}
                </div>
              ))}
            </div>
            <a href="https://meetings-eu1.hubspot.com/michael-wenger?uuid=9cf1d252-81d9-4d0a-ac62-21972be61c70" target="_blank" rel="noopener noreferrer" className="team-section-fox__cta-button">
              <span>{t.teamSection.cta}</span>
              <span className="team-section-fox__cta-icon"><IconArrowRight size={16} /></span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
